var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 11,
    viewBox: "0 0 34 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.633 0.447107C24.0906 0.233232 23.2375 0 22.1748 0C19.4626 0 17.5534 1.44613 17.5376 3.5169C17.5203 5.04864 18.9 5.90288 19.9401 6.412C21.009 6.93386 21.3682 7.26781 21.3639 7.73443C21.3566 8.44814 20.5107 8.77517 19.722 8.77517C18.6236 8.77517 18.0401 8.61417 17.1379 8.21632L16.7851 8.04667L16.4014 10.432C17.0411 10.7288 18.227 10.9865 19.4577 11C22.3402 11 24.2131 9.57133 24.2351 7.36004C24.245 6.1454 23.514 5.22475 21.9308 4.46462C20.9722 3.97046 20.3838 3.64311 20.3905 3.14297C20.3912 2.70011 20.8876 2.22594 21.9621 2.22594C22.8594 2.21146 23.509 2.41888 24.0151 2.63543L24.2615 2.75724L24.633 0.447107ZM11.9397 10.8428L13.6559 0.186377H16.3991L14.6831 10.8428H11.9397ZM29.3781 4.08535C29.3781 4.08535 28.5126 6.45151 28.2853 7.06402H30.5627C30.4543 6.5313 29.9279 3.98778 29.9279 3.98778L29.7427 3.0687C29.6694 3.28021 29.567 3.56068 29.4892 3.7736L29.489 3.77422L29.4889 3.77458L29.4888 3.77469C29.42 3.96329 29.3706 4.09858 29.3781 4.08535ZM29.5505 0.195703H31.6705L33.8907 10.8451H31.3445C31.3445 10.8451 31.0927 9.62037 31.0104 9.24848C30.7986 9.24848 29.9126 9.24694 29.0798 9.24548L29.0755 9.24547L29.0522 9.24543C28.324 9.24417 27.6426 9.24298 27.4968 9.24298C27.3901 9.53129 26.92 10.8451 26.92 10.8451H24.0386L28.1126 1.07906C28.4007 0.38424 28.8929 0.195703 29.5505 0.195703ZM9.63781 0.194434L6.95273 7.45957L6.66514 5.98282C6.66516 5.98288 6.66519 5.98294 6.66521 5.983L5.70387 1.08654C5.53802 0.41124 5.05602 0.211058 4.46026 0.187451H0.0364013L0 0.40825C1.07618 0.684221 2.03852 1.08217 2.8819 1.57713L5.32141 10.8326L8.22474 10.8309L12.5449 0.194434H9.63781Z",
    fill: "url(#paint0_linear_4605_8452)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4605_8452",
    x1: 5.47273,
    y1: 3.78409,
    x2: 20.1223,
    y2: 17.1363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.55e9a2dd07550bddc0a12edefc29a6f2.svg";
export { ForwardRef as ReactComponent };